import React from "react";
import sessionsImg from "../assets/images/fourDays.jpg";

export default function FourDays() {
  return (
    <section className="py-12 sm:py-24 px-4 sm:px-[10%] bg-white">
      <div className="flex flex-col lg:flex-row gap-10">
        <div className="flex-1 space-y-8 lg:space-y-10">
          <header className="space-y-3 sm:space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-[30px] text-left font-roboto font-medium">
              4 Days of Interactive Sessions&nbsp;with&nbsp;Geneen&nbsp;Roth
            </h2>
            <p className="text-sm sm:text-base lg:text-[16px] text-left font-roboto font-normal">
              Participate in transformative, interactive sessions led by Geneen
              herself, designed to guide you through every step of your personal
              journey.
            </p>
          </header>
          <ul className="flex flex-col gap-8 sm:gap-10 lg:gap-10">
            <li>
              <h3 className="text-lg sm:text-xl lg:text-[19px] text-left font-roboto font-semibold">
                Daily Eating&nbsp;Meditations
              </h3>
              <p className="text-sm sm:text-base lg:text-[16px] text-left font-roboto font-normal">
                Practice mindful eating and learn how to truly listen to your
                body’s needs during group meals that offer deep insights into
                your patterns.
              </p>
            </li>
            <li>
              <h3 className="text-lg sm:text-xl lg:text-[19px] text-left font-roboto font-semibold">
                Small Breakout Groups
              </h3>
              <p className="text-sm sm:text-base lg:text-[16px] text-left font-roboto font-normal">
                Engage in small group exercises guided by Geneen to discover and
                share your challenges and breakthroughs.
              </p>
            </li>
            <li>
              <h3 className="text-lg sm:text-xl lg:text-[19px] text-left font-roboto font-semibold">
                Guided Movement and&nbsp;Meditation
              </h3>
              <p className="text-sm sm:text-base lg:text-[16px] text-left font-roboto font-normal">
                Start each day with gentle movement and meditation sessions to
                center yourself, helping you reconnect with your body.
              </p>
            </li>
            <li>
              <h3 className="text-lg sm:text-xl lg:text-[19px] text-left font-roboto font-semibold">
                Ongoing Support After the&nbsp;Retreat
              </h3>
              <p className="text-sm sm:text-base lg:text-[16px] text-left font-roboto font-normal">
                Stay connected with Geneen and the retreat community to support
                your progress with monthly group meetings, personalized small
                group sessions, and peer support.
              </p>
            </li>
          </ul>
        </div>
        <div className="flex-1 flex flex-col items-center lg:items-start w-full lg:max-w-[599px] mx-auto">
          <div className="w-full sm:max-w-[599px] rounded-3xl ring-8 ring-teal-300 overflow-hidden">
            <img
              src={sessionsImg}
              alt="Group video session with Geneen Roth"
              className="w-full h-auto object-cover"
            />
          </div>
          <p className="mt-4 sm:mt-6 text-sm sm:text-base lg:text-[16px] text-left font-roboto font-normal">
            Connect with like-minded women from around the world in intimate,
            supportive group discussions led by Geneen Roth.
          </p>
        </div>
      </div>
    </section>
  );
}